import { Asset } from '../Asset'

/**
 * ResourceFile extends our Asset extension in order to allow
 * resource files to appear as block nodes. Otherwise, it
 * shares all functionality with the Asset extension.
 *
 * The Asset extension's `insertAsset` command will create
 * nodes with this extension if it's enabled and the file
 * is not an image.
 */
export const ResourceFile = Asset.extend({
  name: 'resource',
  marks: '',
  group: 'block',
  inline: false,
  draggable: true,
})
